<template>
    <div class="bg-white mt-3 progress-status-view activity-type-create col-12" :style="themeColor">
        <b-form class="form-sample" @submit.stop.prevent="nextStep">
            <b-row>
                <b-col cols="12" class="dd">
                    <label class="mb-3" for="type_id"><strong>{{ $translate('customer_type') }}</strong><span
                            class="red">*</span></label>
                    <b-form-select class="form-control" v-custom-validation="$selectRequired()" value-field="type_id"
                        text-field="name" id="input-type_id" v-model="model.type_id" required :options="customerTypes">
                        <template #first>
                            <b-form-select-option :value="null">{{ $translate('select_customer_type')
                            }}</b-form-select-option>
                        </template>
                    </b-form-select>

                </b-col>
            </b-row>
            <b-row v-if="model.type_id == 2">
                <b-col cols="12" class="mt-3">
                    <label class="mb-3" for="input-cutomer_name"><strong>{{ $translate('customer_name') }}<span
                                class="red">*</span></strong></label>
                    <b-form-input type="text" id="input-cutomer_name" v-custom-validation="$textRequired()" required
                        v-model="model.customer_name" :placeholder="$translate('enter_name')" trim></b-form-input>
                </b-col>
            </b-row>
            <b-row v-else>
                <b-col cols="6" class="mt-3">
                    <label class="mb-3" for="input-cutomer_fname"><strong>{{ $translate('first_name') }}<span
                                class="red">*</span></strong></label>
                    <b-form-input type="text" id="input-cutomer_fname" v-custom-validation="$textRequired()" required
                        v-model="model.first_name" :placeholder="$translate('enter_first_name')" trim></b-form-input>
                </b-col>
                <b-col cols="6" class="mt-3">
                    <label class="mb-3" for="input-cutomer_lname"><strong>{{ $translate('last_name') }}<span
                                class="red">*</span></strong></label>
                    <b-form-input type="text" id="input-cutomer_lname" v-custom-validation="$textRequired()" required
                        v-model="model.last_name" :placeholder="$translate('enter_last_name')" trim></b-form-input>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" md="6" class="mt-3">
                    <label class="mb-3" for="input-email"><strong>{{ $translate('email_address') }}<span
                                class="red">*</span></strong></label>
                    <b-form-input type="email" id="input-email" v-custom-validation="$emailRequired()" required
                        v-model="model.email" :placeholder="$translate('enter_email')" trim></b-form-input>
                </b-col>
                <b-col cols="12" md="6" class="mt-3">
                    <label class="mb-3" for="input-number"><strong>{{ $translate('phone_number') }}<span
                                class="red">*</span></strong></label>
                    <b-form-input type="number" id="input-number" required v-custom-validation="$textRequired()"
                        v-model.number="model.phone" :placeholder="$translate('phone_number_placeholder')"
                        trim></b-form-input>
                </b-col>
            </b-row>
            <b-col class="mt-3 d-flex">
                <div class="form-check me-1">
                    <label class="form-check-label">
                        <input type="checkbox" id="input-agreed-to-terms" v-model="model.agreed_to_terms"  name="input-agreed-to-terms"
                            :value="1" :unchecked-value="0" />
                        <i class="input-helper"></i>
                    </label>
                </div>
                <div>
                    <span>{{ $translate('i_agree_to') }} {{ companySettingData.name }}
                        <span v-if="termsOfServiceDocumentUrl" class="m-1"><a :href="termsOfServiceDocumentUrl"
                                target="_blank">
                                {{ $translate('terms_of_service') }}</a></span>
                        <span class="m-1" v-else>{{ $translate('terms_of_service') }}</span><span class="m-0"> {{
                            $translate('and') }} </span>
                        <span class="m-1" v-if="privacyPolicyDocumentUrl"><a
                                :href="privacyPolicyDocumentUrl"
                                target="_blank">{{ $translate('privacy_policy') }}</a></span>
                        <span class="m-1" v-else>{{
                            $translate('privacy_policy') }}</span></span>
                </div>
            </b-col>
            <b-col class="mt-5 text-center">
                <b-button type="submit" class="btn btn-info btn-fw me-2 " variant="primary">{{ $translate('next')
                }}</b-button>

            </b-col>
        </b-form>

    </div>
</template>
<script>
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'customerUsers-profile',
    mixins: [permissionsMixins],
    data() {
        return {
            customerTypes: [
                { type_id: 1, name: this.$translate('individual') },
                { type_id: 2, name: this.$translate('company') },
                // Add more options as needed
            ],
            loading: false,
            hasErrors: false,
        }
    },
    props: ['value', 'themeColor', 'companySettingData'],
    computed: {
        companyPolicyKey() {
            return this.$store.state.company.settingKeys.companyPolicyKey
        },
        companyPolicyValue() {
            const companyPolicy = this.$store.getters['company/companyPolicyValue']
            return companyPolicy
        },
        termsOfServiceDocumentUrl() {
                const url = this.companyPolicyValue && this.companyPolicyValue.terms_of_service 
                return url
        },
        privacyPolicyDocumentUrl() {
            const url = this.companyPolicyValue && this.companyPolicyValue.privacy_policy 
            return url
        },
        model: {
            get() {
                console.log('...........', this.value)
                return this.value
            },
        }
    },
    methods: {
        nextStep() {
            this.$emit('next-clicked'); // Emit the custom event
        },
    },
}
</script>
<style></style>
